import { CGame } from "./CGame";
import { CConfig } from "./CConfig";

export class CTPGHMenu {
    private m_mc:fgui.GComponent;
    private m_TPGH:number;
    private m_Show:number;
    private m_tx:number;
    private m_Game:CGame;
    private m_inFunc:Function;

    constructor() {
        this.m_Game = CGame.Instance;
    }

    public release(clickfunc:PIXI.utils.EventEmitter.ListenerFn):void {
        this.m_Game.SetGOCallbackFunc(this.m_mc, "mc_btnTPGH", 4, clickfunc, false, this);
    }

    public init(mc:fgui.GComponent, clickfunc:PIXI.utils.EventEmitter.ListenerFn, inFunc:Function = null):void {
        this.m_inFunc = inFunc;
        this.m_mc = mc;
        this.m_TPGH = 0;
		this.m_Show = 0;
		this.m_tx = this.m_mc.x;
        this.m_Game.SetGOCallbackFunc(this.m_mc, "mc_btnTPGH", 6, clickfunc, true, this);
    }

    public GetState():number { return this.m_Show; }
		
    public isEnable(v:number):number {
        return (this.m_TPGH & (1 << v));
    }

    public Out():void {
        if ( !this.m_mc.visible ) return;
        //createjs.Tween.removeTweens(this.m_mc);
        var that = this;
        createjs.Tween.get(this.m_mc, {override:true})
            .to({ x:CConfig.gameWD}, 350, createjs.Ease.quadOut)
            .call(function(){
                that.endTPGHMove(false);
            }) 
    }

    public In(tpgh:number, md:number):void {
        this.m_TPGH = tpgh;
        if( tpgh & (1 << 3) ) this.m_TPGH |= (1 << 3);
        this.m_TPGH |= (1 << 5);
        this.m_Show = 1;
        this.m_mc.visible = true;
        for ( var i:number = 0; i < 6; i ++ ) {
            let mc = this.m_mc.getChild("mc_btnTPGH" + i) as fgui.GButton;
            mc.visible = true;
            mc.alpha = 0.5;
            mc.enabled = false;
        }
        this.m_mc.x = CConfig.gameWD;
        var that = this;
        createjs.Tween.get(this.m_mc, {override:true})
                .to({x:this.m_tx}, 200, createjs.Ease.quadOut)
                .call(function(){
                    that.endTPGHMove(true);
                });
    }

    private endTPGHMove(mode:boolean):void {
        if ( mode ) {	// move in
            var i:number;
            for ( i = 0; i < 6; i ++ ) {
                if( (this.m_TPGH & (1 << i)) || i == 5 ) {
                    let mc = this.m_mc.getChild("mc_btnTPGH" + i) as fgui.GButton;
                    mc.enabled = true;
                    mc.alpha = 1.0;
                }
            }
            this.m_Show = 3;
            var that = this;
            createjs.Tween.get(this.m_mc)
                .to({x:this.m_tx}, 50, createjs.Ease.quadOut)
                .call(function(){
                    that.endTPGHWait();
                });
        }
        else {
            this.m_mc.visible = false;
            this.m_Show = 0;
        }
    }

    private endTPGHWait():void {
        this.m_Show = 5;
        if( this.m_inFunc ) this.m_inFunc();
    }
}